import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { CmfInterface } from '../../../interface/cmf-interface';
import { CmfServiceService } from '../../../service/cmf-service.service';

@Component({
  selector: 'app-cmf-form',
  templateUrl: './cmf-form.component.html',
  styleUrls: ['./cmf-form.component.scss'],
})
export class CmfFormComponent {

  public booleanFlag: boolean;
  public update: boolean;
  constructor(
    private cmfService: CmfServiceService,
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<CmfFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: number
  ) { }

  formRegisterCmf = new FormGroup({
    currentAmount: new FormControl('', [Validators.required]),
    fechaDeuda: new FormControl(),
    debtAmount: new FormControl(),
    line: new FormControl(),
  });

  get f() {
    return this.formRegisterCmf.controls;
  }

  submit() {

    var rut: number = 0;

    this.route.queryParams.subscribe(params => {
      rut = params['client'] || null;
      console.log("Cliente: " + rut);
    });

    var { currentAmount, fechaDeuda, debtAmount, line } = this.formRegisterCmf.value;

    const cmf: CmfInterface = {
      companyId: rut,
      debtAmount: parseInt(debtAmount),
      debtDate: fechaDeuda,
      lineAmount: line,
      currentAmount: parseInt(currentAmount)
    };

    this.booleanFlag = true;
    this.cmfService.newCmf(cmf).subscribe({
      next: (next) => {
        this.booleanFlag = false;
        Swal.fire({
          title: 'Registro Realizado',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            this.update = true;
            this.dialogRef.close(this.update);
          }
        });
      },
      error: (error) => {
        Swal.fire({
          title: 'Error',
          text: error.error,
          icon: 'error',
          timerProgressBar: true,
        });
        this.booleanFlag = false;
      },
    });
  }
  cerrarDialogo() {
    this.dialogRef.close();
  }
}
